import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate, Link } from "react-router-dom";
import { Lock, Mail, ArrowRight } from "lucide-react";
import toast from "react-hot-toast";

import { api } from "../../lib/api";
import { useAuth } from "../../lib/auth";

export default function Login() {
  const { register, handleSubmit } = useForm({ defaultValues: { email: "admin@balajicaterers.com", password: "" } });
  const { setAuth } = useAuth();
  const nav = useNavigate();
  const [loading, setLoading] = useState(false);

  const onSubmit = async (data) => {
    setLoading(true);
    try {
      const r = await api.post("/auth/login", data);
      setAuth(r.data.access_token, r.data.user);
      toast.success("Welcome to the royal control room");
      if (r.data.user?.must_change_password) nav("/admin/change-password");
      else nav("/admin");
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Login failed");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex">
      {/* left visual */}
      <div className="hidden lg:flex flex-1 relative bg-navy-900 overflow-hidden">
        <img src="https://images.unsplash.com/photo-1587271407850-8d438ca9fdf2?auto=format&fit=crop&w=1400&q=80" className="absolute inset-0 w-full h-full object-cover opacity-50" alt="" />
        <div className="absolute inset-0 hero-overlay" />
        <div className="relative z-10 flex flex-col justify-between p-14 text-ivory">
          <div className="serif text-2xl">Shree Balaji <span className="text-gold">Caterers</span></div>
          <div>
            <div className="label-eyebrow text-gold mb-3">Royal Control Room</div>
            <h2 className="serif text-5xl leading-tight">Where every<br /><em className="text-shimmer not-italic">plate begins</em>.</h2>
            <p className="text-ivory/70 mt-5 max-w-md">Manage menus, packages, gallery, leads, quotations & GST invoices — all from one bespoke dashboard built for your house.</p>
          </div>
          <div className="text-ivory/40 text-xs">© Shree Balaji Caterers · Vadodara</div>
        </div>
      </div>

      {/* form */}
      <div className="flex-1 bg-ivory flex items-center justify-center p-8">
        <form onSubmit={handleSubmit(onSubmit)} className="w-full max-w-md" data-testid="login-form">
          <div className="label-eyebrow">Administrator Login</div>
          <h1 className="serif text-4xl mt-2">Pranam · Welcome back.</h1>
          <p className="text-navy-900/60 mt-2 text-sm">Sign in to manage the Balaji platform.</p>

          <label className="label mt-8">Email</label>
          <div className="relative">
            <Mail size={16} className="absolute left-4 top-1/2 -translate-y-1/2 text-navy-900/60" />
            <input className="input pl-10" type="email" {...register("email", { required: true })} data-testid="login-email" />
          </div>
          <label className="label mt-4">Password</label>
          <div className="relative">
            <Lock size={16} className="absolute left-4 top-1/2 -translate-y-1/2 text-navy-900/60" />
            <input className="input pl-10" type="password" {...register("password", { required: true })} data-testid="login-password" />
          </div>

          <button type="submit" disabled={loading} className="btn-gold w-full mt-7 justify-center" data-testid="login-submit">
            {loading ? "Signing in…" : <>Enter Control Room <ArrowRight size={14} /></>}
          </button>

          <Link to="/" className="text-navy-900/55 text-xs mt-6 inline-block hover:text-gold tracking-wider uppercase" data-testid="back-home-link">← Back to website</Link>
        </form>
      </div>
    </div>
  );
}
